import { Stack } from 'expo-router';

import { primitive } from 'styles/constants';

export default function DrawerLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen
        name="account/index"
        options={{
          presentation: 'containedTransparentModal',
          contentStyle: { backgroundColor: 'transparent' },
          animation: 'none',
        }}
      />
    </Stack>
  );
}
